import http from "@/tools/http";

export default {
  getAll(organizationUUID) {
    return http.get(`/organizations/${organizationUUID}/sso`);
  },
  update(organizationUUID, data) {
    return http.post(`/organizations/${organizationUUID}/sso`, data);
  },
  delete(organizationUUID, ssoUUID) {
    return http.delete(`/organizations/${organizationUUID}/sso/${ssoUUID}`);
  }
};
